import {
    createStore,
    applyMiddleware,
    compose
} from 'redux';
import thunk from 'redux-thunk';
import { middleware as reduxPackMiddleware } from 'redux-pack';
import rootReducer from '../reducers';

export default createStore(
    rootReducer,
    compose(
        applyMiddleware(thunk, reduxPackMiddleware)
    )
);
